export default "__VITE_PUBLIC_ASSET__72cceeb2__"